import { SfLog } from '@app/adapters/logger'
import { onDocumentEvent, prevAll } from '@app/utils/domHelpers'
import SFetch from '@app/utils/sfetch'

const handleAddAccountRange = (event) => {
  /**
   * TODO: Here we are adding a new element to the DOM by cloning an existing one, manipulating its properties and then reinserting as a sibling.
   * At a minimum we shouldn't rely on the DOM element but rather construct the new element from a template existing in JS memory.
   * Consider turning into Vue Components, e.g. a managing component that keeps track of how many inputs exists, with + / - buttons that remove the elements.
   * */

  event.preventDefault()

  const button = event.target.closest('button')
  const table = prevAll(button, 'table')[0]
  const inputClone = table.querySelector('.new-account-range').cloneNode(true)

  requestAnimationFrame(() => {
    inputClone.classList.remove('new-account-range')
    inputClone.style.display = 'table-row'

    const allInputs = inputClone.querySelectorAll('input')

    // Account range & paperclip toggle
    allInputs.forEach((input) => {
      input.removeAttribute('disabled')
    })

    table.querySelector('.account-ranges').appendChild(inputClone)
  })
}

const handleRemoveAccountRange = (event) => {
  event.preventDefault()

  const elementToRemove = event.target.closest('tr')

  requestAnimationFrame(() => {
    elementToRemove.remove()
  })
}

const handleExportReportConfigChange = (event) => {
  const exportElement = event.target.closest(
    '[data-behaviour~="export-element"]'
  )

  const loader = exportElement.querySelector(
    '[data-behaviour="export-configuration-report-form-loading"]'
  )

  const reportForm = exportElement.querySelector(
    '[data-behaviour="export-configuration-report-form"]'
  )

  requestAnimationFrame(async () => {
    if (loader) {
      loader.style.display = 'inline-block'
    }

    try {
      const result = await SFetch.raw(
        `${Silverfin.Routes.report_form_export_configuration_path(
          Silverfin.currentFirmId,
          event.target.dataset.exportConfigurationId
        )}?${new URLSearchParams({
          report_id: event.target.value,
        })}`,
        { method: 'GET' }
      )

      const newFormText = await result.text()
      reportForm.innerHTML = ''
      reportForm.insertAdjacentHTML('afterbegin', newFormText)
    } catch (e) {
      SfLog.warn('Failed to load export configuration', {
        extra: {
          error: e,
        },
      })
    }
  })
}

export default () => {
  const unsubscribers = [
    onDocumentEvent(
      document,
      'click',
      '[data-behaviour="add-account-range"]',
      handleAddAccountRange
    ),
    onDocumentEvent(
      document,
      'click',
      '[data-behaviour="remove-account-range"]',
      handleRemoveAccountRange
    ),
    onDocumentEvent(
      document,
      'change',
      '[data-behaviour="export-configuration-report-select"]',
      handleExportReportConfigChange
    ),
  ]

  return () => {
    unsubscribers.forEach((unsubscribe) => unsubscribe())
  }
}
